import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ApplicationLayout from './applicationLayout';
import PrivateRoute from './PrivateRoute';
import { useAuthStore } from './store/authStore';
import LeaguesPage from './pages/LeaguesPage';
import TournamentsPage from './pages/TournamentsPage';
import TournamentPage from './pages/Tournament/TournamentPage';
import AnnualReportsPage from './pages/AnnualReportsPage';
import EditProfilePage from './pages/EditProfilePage';
import SupportPage from './pages/SupportPage';
import ResultSubmissionPage from './pages/League/ResultSubmissionPage';
import PlayersCopyLocalPage from './pages/League/PlayersCopyLocalPage';

const routesConfig = [
  {
    path: '/',
    element: <LoginPage />,
    private: false,
    layout: false,
  },
  {
    path: '/League',
    element: <LeaguesPage />,
    private: true,
    layout: true,
  },
  {
    path: '/support',
    element: <SupportPage />,
    private: true,
    layout: true,
  },
  {
    path: '/annual-reports',
    element: <AnnualReportsPage />,
    private: true,
    layout: true,
  },
  {
    path: '/league/result-submission/:leagueId/:classId/:teamId/:registrationId/:day',
    element: <ResultSubmissionPage />,
    private: true,
    layout: true,
  },
  {
    path: '/league/players-copy-Local/:registrationId',
    element: <PlayersCopyLocalPage />,
    private: true,
    layout: true,
  },
  {
    path: '/tournaments',
    element: <TournamentsPage />,
    private: true,
    layout: true,
  },
  {
    path: '/tournaments/:id',
    element: <TournamentPage />,
    private: true,
    layout: true,
  },
  {
    path: '/profile',
    element: <EditProfilePage />,
    private: true,
    layout: true,
  },
];

const RouterConfig: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  return (
    <Router>
      <Routes>
        {routesConfig.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.private ? (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  {route.layout ? (
                    <ApplicationLayout>{route.element}</ApplicationLayout>
                  ) : (
                    route.element
                  )}
                </PrivateRoute>
              ) : route.layout ? (
                <ApplicationLayout>{route.element}</ApplicationLayout>
              ) : (
                route.element
              )
            }
          />
        ))}
      </Routes>
    </Router>
  );
};

export default RouterConfig;
